/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Submit_Badge_CopiedInputs */

const en_directory_submit_badge_copied = /** @type {(inputs: Directory_Submit_Badge_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Badge code copied`)
};

const zh_directory_submit_badge_copied = /** @type {(inputs: Directory_Submit_Badge_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`徽章代码已复制`)
};

/**
* | output |
* | --- |
* | "Badge code copied" |
*
* @param {Directory_Submit_Badge_CopiedInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_submit_badge_copied = /** @type {((inputs?: Directory_Submit_Badge_CopiedInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Submit_Badge_CopiedInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_submit_badge_copied(inputs)
	return zh_directory_submit_badge_copied(inputs)
});
export { directory_submit_badge_copied as "directory.submit.badge_copied" }